module.exports = __webpack_public_path__ + "img/tick.22652066.svg";